import { selectExternalConfigs } from "../../redux/feature/settings/configurations-slice";
import { store } from "../../redux/store/store";
import { ApiVersion } from "../../api/models/api-version";

export const getVersionedApiUrl = (apiUrl: string): string => {
  let apiVersioning = selectExternalConfigs(store.getState()).apiVersion as ApiVersion;
  if (apiUrl in apiVersioning) return `/${apiVersioning[apiUrl]}${apiUrl}`;
  return apiUrl;
};

export const isCpmVersionLess = (target): boolean => {
  // TODO build a custom selector for this case,
  //  so we can rely on the hook useAppSelector

  const cpmVersion = selectExternalConfigs(store.getState()).cpmVersion;
  if (!cpmVersion) return true;
  const v1 = cpmVersion.split(".").map(Number);
  const v2 = target.split(".").map(Number);

  for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
    const num1 = v1[i] || 0;
    const num2 = v2[i] || 0;

    if (num1 < num2) return true;
    if (num1 > num2) return false;
  }
  return false; // Cambiato da true a false
};
